import { isSuccess } from './outcomes.js'

export function paymentLabel(conv) {
  const payment = conv?.order_payment
  if (!payment) return ''
  const label = { paid: '已付款', unpaid: '未付款', refunded: '已退款', unknown: '支付状态未知' }[payment.state]
  return label || '支付状态未知'
}

export function displayOutcome(conv) {
  if (isSuccess(conv?.outcome)) return conv.outcome
  const payment = conv?.order_payment
  return (payment?.state === 'paid' && payment.outcome) || conv?.outcome || ''
}

export function resultPlaceholder(conv) {
  if (conv?.order_payment?.state === 'paid') return '已付款 · 待核实套餐'
  if (conv?.order_payment?.state === 'refunded') return '已退款'
  return '未标记结果'
}
